/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EntityOrigin = {
    UserDefined: 'UserDefined',
    Predefined: 'Predefined'
} as const;
export type EntityOrigin = typeof EntityOrigin[keyof typeof EntityOrigin];


export function EntityOriginFromJSON(json: any): EntityOrigin {
    return EntityOriginFromJSONTyped(json, false);
}

export function EntityOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityOrigin {
    return json as EntityOrigin;
}

export function EntityOriginToJSON(value?: EntityOrigin | null): any {
    return value as any;
}

/**
 * Check if a given object implements the EntityOrigin interface.
 */
 export function instanceOfEntityOrigin(value: any): value is EntityOrigin {
    return Object.values(EntityOrigin).includes(value)
}

